import React from 'react';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { Copy, SystemText } from '@salesperformanceint/e4shared';

export const Sorter = ({ label, help, options, orderProp, onChange, narrow, distance }) => {
    const onSortEnd = item => {
        const { oldIndex, newIndex } = item;
        options.sort(c => c[orderProp || 'sequence']);
        const newOptions = arrayMove(options, oldIndex, newIndex);
        newOptions.forEach((c, i) => {
            c[orderProp || 'sequence'] = i;
        });
        onChange?.(newOptions);
    };

    const DragHandle = SortableHandle(({ children }) => (
        <div title={SystemText('General/Controls/Drag/Hover')} style={{ zIndex: 9999 }}>
            {children}
        </div>
    ));

    const SortableItem = SortableElement(({ value }) => (
        <DragHandle>
            <div className="flex drag-item mb3">
                <div className={narrow ? 'p5 pr10 pl10' : 'p10'}>
                    <i className="fa fa-ellipsis-v" />
                </div>
                <div className={`flex flex-grow flex-center ${narrow ? 'p5 pr10 pl10' : 'p10'}`}>
                    <span className="flex-grow">
                        {value.name} {value.icon && <span>{value.icon()}</span>}
                    </span>
                    {typeof value.extra === 'function' && value.extra()}
                </div>
            </div>
            {value.subSorter && value.subSorter()}
        </DragHandle>
    ));

    const SortableList = SortableContainer(({ items }) => {
        return (
            <ul className="p0">
                {items
                    .sort((a, b) => (a[orderProp || 'sequence'] > b[orderProp || 'sequence'] ? 1 : -1))
                    .map((value, index) => {
                        const key = `item-${value.id}-${index}`;
                        return <SortableItem key={key} index={index} distance="5" value={value} />;
                    })}
            </ul>
        );
    });

    return (
        <div className="form-group sorter">
            {label && <label>{label}</label>}
            {help && (
                <span className="form-control-help">
                    <Copy value={help} />
                </span>
            )}
            <SortableList items={options} distance={distance} useDragHandle onSortEnd={onSortEnd} axis="y" />
        </div>
    );
};

export default Sorter;
